import { Box, IconButton, Typography } from '@mui/material'
import BaseModal from '../../../../components/modal/baseModal'
import { icons } from '../../../../utils/icons'
import { Props } from './props'
import { useStyles } from './styles'
import { useContextState } from '../../../../hooks/theme'


const CreateFolioModal = ({ arrayButtons, close, description, open, title, closeProps, sx }: Props) => {
    const styles = useStyles()
    const { colors: color } = useContextState()
    return (
        <BaseModal open={open} sx={{ borderRadius:2, width: '500px', maxHeight: '90vh', overflow: 'auto', ...(sx ?? {}) }}>
            <Box sx={styles.containerSuccess}>
                <IconButton
                    {...closeProps}
                    sx={closeProps?.sx ?? styles.closeSuccess}
                    onClick={() => {
                        close()
                    }}
                >
                    {icons('simple-close')}
                </IconButton>
                <Box>
                    <Box className="container">
                        <Typography variant='title_grey_dark'>{title}</Typography>
                        <Typography className='description'>{description}</Typography>
                    </Box>
                    {arrayButtons &&
                        <>
                            {arrayButtons.map((item, index) => (
                                <Box key={index} sx={styles.butonContainer}>
                                    <Box sx={styles.w10} className='icon'>
                                        <svg xmlns="http://www.w3.org/2000/svg" height="34" viewBox="0 0 24 24" width="34">
                                            <defs>
                                                <linearGradient id={`myGradient${index}`} x1="0%" y1="0%" x2="0%" y2="100%">
                                                    <stop offset="0%" stop-color={`${color.color1}`}  stop-opacity="1" />
                                                    <stop offset="50%" stop-color={`${color.primary}`} stop-opacity="1" />
                                                    <stop offset="100%" stop-color={`${color.color2}`} stop-opacity="1" />
                                                </linearGradient>
                                            </defs>
                                            <path d={item.path} fill={`url(#myGradient${index})`} />
                                        </svg>
                                    </Box>

                                    <Box sx={styles.w74}>
                                        <Typography className='title'>{item.title}</Typography>
                                        <Typography className='description'>{item.description}</Typography>
                                    </Box>
                                    <IconButton sx={styles.w15} className='icon' onClick={item.onClick}>{icons('arrow-r')}</IconButton>
                                </Box>
                            ))}
                        </>
                    }
                </Box>
            </Box>
        </BaseModal>
    )
}

export default CreateFolioModal
